import { useMediaQuery } from "@mui/material";
import React from "react";
import NavBar from "../NavBar/NavBar";
import "./Background.scss";

const Background = ({ children, backButtonUrl }) => {
  const mobileView = useMediaQuery("(max-width:630px)");


  const navbarHeight = mobileView ? 55 : 125;
  // to update the height of overlay as pe window height
  window.addEventListener('resize', () => {
    const windowHeight = window.innerHeight;
    const mainContainerBox = document.querySelector('.main-container-box');
    if(mainContainerBox) mainContainerBox.style.height = `${windowHeight - navbarHeight}px`;
  });
  // Initial calculation on page load
  window.dispatchEvent(new Event('resize'));


  return (
    <div className="background-main" >
      <div className="background-content">
        <NavBar backButtonUrl={backButtonUrl} />
        <div className="main-container-box" >{children}</div>

      </div>
    </div>
  )
}

export default Background;
